module.exports = __webpack_public_path__ + "fae778cb7ce09a41fd70a387700defc3.MP3";